<template>
    <div class="modal fade" tabindex="-1" v-if="show">
        <div class="modal-dialog">
            <div class="modal-content">
                <slot name="header">
                <div class="modal-header">
                    <h5 class="modal-title pull-left">
                        <i v-if="titleIcon" class="modal-title-icon zmdi" :class="titleIcon"></i>
                        <span>{{ title }}</span>
                    </h5>
                </div>
                </slot>
                <div class="modal-body">
                    <slot name="body">{{ description }}</slot>
                </div>
                <div class="modal-footer">
                    <slot name="footer">
                        <button type="submit" class="btn btn-success float-right text-uppercase" @click="$emit('modal-submited')">{{ submitButtonLabel }}</button>
                        <button type="button" class="btn btn-link" data-dismiss="modal">{{ closeLabel }}</button>
                    </slot>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                show: true
            }
        },

        props: {
            title: {default: ''},
            titleIcon: '',
            submitButtonLabel: {default: 'LBL_SAVE'},
            description: {default: ''},
            closeButtonLabel: {default: 'Close'}
        },

        computed: {
            element() {
                return $(this.$el)
            },

            closeLabel() {
                return this.closeButtonLabel
            }
        },

        methods: {
            close() {
                this.element.modal('hide')
                this.show = false
            }
        },

        mounted() {
            this.element.modal()
        },
    }
</script>
